/**
 * @generated SignedSource<<506376d0cca3d62e7e0cb3a455461b31>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotosSearchBrowseSocialIcons_photos$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly " $fragmentSpreads": FragmentRefs<"usePhotosLikeDataRefetch_photos">;
    } | null;
  } | null> | null;
  readonly " $fragmentType": "PhotosSearchBrowseSocialIcons_photos";
};
export type PhotosSearchBrowseSocialIcons_photos$key = {
  readonly " $data"?: PhotosSearchBrowseSocialIcons_photos$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowseSocialIcons_photos">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhotosSearchBrowseSocialIcons_photos",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PhotosSearchBrowseQueryEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PhotosSearchBrowsePhoto",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "usePhotosLikeDataRefetch_photos"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PhotosSearchBrowseQueryConnection",
  "abstractKey": null
};

(node as any).hash = "e831f4425b4dd213f696e025d682e364";

export default node;
